export const isLoadingHolding = state => state.config.advanced.holdingConfig.holding.loading;
export const getHolding = state => state.config.advanced.holdingConfig.holding.data;
export const errorHolding = state => state.config.advanced.holdingConfig.holding.error;
export const getHoldingFunnels = state => state.config.advanced.holdingConfig.holding.funnels || [];